var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFavoriteActive = function SvgFavoriteActive(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 22 22"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.257 2.286a5.957 5.957 0 0 1 7.787 3.225 5.958 5.958 0 0 1-1.292 6.495l-8.104 8.103a.917.917 0 0 1-1.296 0l-8.103-8.103a5.96 5.96 0 1 1 8.428-8.428L11 3.9l.323-.323a5.958 5.958 0 0 1 1.666-1.174l.268-.118Z"
  })));
};
export default SvgFavoriteActive;